module.exports = __webpack_public_path__ + "tinymce.9267f79bc730290c6e2c.woff";


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/tinymce/skins/lightgray/fonts/tinymce.woff
// module id = ../../../../../src/assets/tinymce/skins/lightgray/fonts/tinymce.woff
// module chunks = styles